var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CB001C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#2A3560;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 382.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 23,
    width: 512,
    y: 359.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 336.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 23,
    width: 512,
    y: 313.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 290.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 23,
    width: 512,
    y: 267.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 244.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 23,
    width: 512,
    y: 221.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 198.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 23,
    width: 512,
    y: 175.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 152.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 23,
    width: 512,
    y: 129.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 23,
    width: 512,
    y: 106.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 160.8,
    width: 233.8,
    y: 106.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.1,124.4 23.1,130.5 29.4,130.5 24.3,134.2 26.2,140.3 21.1,136.5 15.9,140.3 17.9,134.2    12.7,130.5 19.1,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.1,151.2 23.1,157.3 29.4,157.3 24.3,161.1 26.2,167.1 21.1,163.4 15.9,167.1 17.9,161.1    12.7,157.3 19.1,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.1,178.1 23.1,184.2 29.4,184.2 24.3,187.9 26.2,194 21.1,190.2 15.9,194 17.9,187.9 12.7,184.2    19.1,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.1,204.9 23.1,211 29.4,211 24.3,214.8 26.2,220.8 21.1,217.1 15.9,220.8 17.9,214.8 12.7,211    19.1,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.1,231.8 23.1,237.8 29.4,237.8 24.3,241.6 26.2,247.7 21.1,243.9 15.9,247.7 17.9,241.6    12.7,237.8 19.1,237.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.8,138.5 41.8,144.6 48.1,144.6 43,148.4 44.9,154.4 39.8,150.7 34.6,154.4 36.6,148.4 31.4,144.6    37.8,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.8,165.4 41.8,171.4 48.1,171.4 43,175.2 44.9,181.3 39.8,177.5 34.6,181.3 36.6,175.2 31.4,171.4    37.8,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.8,192.2 41.8,198.3 48.1,198.3 43,202.1 44.9,208.1 39.8,204.4 34.6,208.1 36.6,202.1 31.4,198.3    37.8,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.8,219.1 41.8,225.1 48.1,225.1 43,228.9 44.9,235 39.8,231.2 34.6,235 36.6,228.9 31.4,225.1    37.8,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.7,124.4 60.7,130.5 67.1,130.5 61.9,134.2 63.9,140.3 58.7,136.5 53.5,140.3 55.5,134.2    50.3,130.5 56.7,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.7,151.2 60.7,157.3 67.1,157.3 61.9,161.1 63.9,167.1 58.7,163.4 53.5,167.1 55.5,161.1    50.3,157.3 56.7,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.7,178.1 60.7,184.2 67.1,184.2 61.9,187.9 63.9,194 58.7,190.2 53.5,194 55.5,187.9 50.3,184.2    56.7,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.7,204.9 60.7,211 67.1,211 61.9,214.8 63.9,220.8 58.7,217.1 53.5,220.8 55.5,214.8 50.3,211    56.7,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.7,231.8 60.7,237.8 67.1,237.8 61.9,241.6 63.9,247.7 58.7,243.9 53.5,247.7 55.5,241.6    50.3,237.8 56.7,237.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.4,138.5 79.4,144.6 85.8,144.6 80.6,148.4 82.6,154.4 77.4,150.7 72.2,154.4 74.2,148.4 69,144.6    75.4,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.4,165.4 79.4,171.4 85.8,171.4 80.6,175.2 82.6,181.3 77.4,177.5 72.2,181.3 74.2,175.2 69,171.4    75.4,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.4,192.2 79.4,198.3 85.8,198.3 80.6,202.1 82.6,208.1 77.4,204.4 72.2,208.1 74.2,202.1 69,198.3    75.4,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "77.4,219.1 79.4,225.1 85.8,225.1 80.6,228.9 82.6,235 77.4,231.2 72.2,235 74.2,228.9 69,225.1    75.4,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.3,124.4 98.3,130.5 104.7,130.5 99.5,134.2 101.5,140.3 96.3,136.5 91.2,140.3 93.2,134.2    88,130.5 94.4,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.3,151.2 98.3,157.3 104.7,157.3 99.5,161.1 101.5,167.1 96.3,163.4 91.2,167.1 93.2,161.1    88,157.3 94.4,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.3,178.1 98.3,184.2 104.7,184.2 99.5,187.9 101.5,194 96.3,190.2 91.2,194 93.2,187.9 88,184.2    94.4,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.3,204.9 98.3,211 104.7,211 99.5,214.8 101.5,220.8 96.3,217.1 91.2,220.8 93.2,214.8 88,211    94.4,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "96.3,231.8 98.3,237.8 104.7,237.8 99.5,241.6 101.5,247.7 96.3,243.9 91.2,247.7 93.2,241.6    88,237.8 94.4,237.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115,138.5 117,144.6 123.4,144.6 118.2,148.4 120.2,154.4 115,150.7 109.9,154.4 111.8,148.4    106.7,144.6 113.1,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115,165.4 117,171.4 123.4,171.4 118.2,175.2 120.2,181.3 115,177.5 109.9,181.3 111.8,175.2    106.7,171.4 113.1,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115,192.2 117,198.3 123.4,198.3 118.2,202.1 120.2,208.1 115,204.4 109.9,208.1 111.8,202.1    106.7,198.3 113.1,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115,219.1 117,225.1 123.4,225.1 118.2,228.9 120.2,235 115,231.2 109.9,235 111.8,228.9 106.7,225.1    113.1,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134,124.4 136,130.5 142.3,130.5 137.2,134.2 139.1,140.3 134,136.5 128.8,140.3 130.8,134.2    125.6,130.5 132,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134,151.2 136,157.3 142.3,157.3 137.2,161.1 139.1,167.1 134,163.4 128.8,167.1 130.8,161.1    125.6,157.3 132,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134,178.1 136,184.2 142.3,184.2 137.2,187.9 139.1,194 134,190.2 128.8,194 130.8,187.9 125.6,184.2    132,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134,204.9 136,211 142.3,211 137.2,214.8 139.1,220.8 134,217.1 128.8,220.8 130.8,214.8 125.6,211    132,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134,231.8 136,237.8 142.3,237.8 137.2,241.6 139.1,247.7 134,243.9 128.8,247.7 130.8,241.6    125.6,237.8 132,237.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.7,138.5 154.6,144.6 161,144.6 155.9,148.4 157.8,154.4 152.7,150.7 147.5,154.4 149.5,148.4    144.3,144.6 150.7,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.7,165.4 154.6,171.4 161,171.4 155.9,175.2 157.8,181.3 152.7,177.5 147.5,181.3 149.5,175.2    144.3,171.4 150.7,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.7,192.2 154.6,198.3 161,198.3 155.9,202.1 157.8,208.1 152.7,204.4 147.5,208.1 149.5,202.1    144.3,198.3 150.7,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.7,219.1 154.6,225.1 161,225.1 155.9,228.9 157.8,235 152.7,231.2 147.5,235 149.5,228.9    144.3,225.1 150.7,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171.6,124.4 173.6,130.5 180,130.5 174.8,134.2 176.8,140.3 171.6,136.5 166.4,140.3 168.4,134.2    163.2,130.5 169.6,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171.6,151.2 173.6,157.3 180,157.3 174.8,161.1 176.8,167.1 171.6,163.4 166.4,167.1 168.4,161.1    163.2,157.3 169.6,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171.6,178.1 173.6,184.2 180,184.2 174.8,187.9 176.8,194 171.6,190.2 166.4,194 168.4,187.9    163.2,184.2 169.6,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171.6,204.9 173.6,211 180,211 174.8,214.8 176.8,220.8 171.6,217.1 166.4,220.8 168.4,214.8    163.2,211 169.6,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "171.6,231.8 173.6,237.8 180,237.8 174.8,241.6 176.8,247.7 171.6,243.9 166.4,247.7 168.4,241.6    163.2,237.8 169.6,237.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "190.3,138.5 192.3,144.6 198.7,144.6 193.5,148.4 195.5,154.4 190.3,150.7 185.1,154.4 187.1,148.4    181.9,144.6 188.3,144.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "190.3,165.4 192.3,171.4 198.7,171.4 193.5,175.2 195.5,181.3 190.3,177.5 185.1,181.3 187.1,175.2    181.9,171.4 188.3,171.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "190.3,192.2 192.3,198.3 198.7,198.3 193.5,202.1 195.5,208.1 190.3,204.4 185.1,208.1 187.1,202.1    181.9,198.3 188.3,198.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "190.3,219.1 192.3,225.1 198.7,225.1 193.5,228.9 195.5,235 190.3,231.2 185.1,235 187.1,228.9    181.9,225.1 188.3,225.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "209.2,124.4 211.2,130.5 217.6,130.5 212.4,134.2 214.4,140.3 209.2,136.5 204.1,140.3 206,134.2    200.9,130.5 207.3,130.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "209.2,151.2 211.2,157.3 217.6,157.3 212.4,161.1 214.4,167.1 209.2,163.4 204.1,167.1 206,161.1    200.9,157.3 207.3,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "209.2,178.1 211.2,184.2 217.6,184.2 212.4,187.9 214.4,194 209.2,190.2 204.1,194 206,187.9    200.9,184.2 207.3,184.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "209.2,204.9 211.2,211 217.6,211 212.4,214.8 214.4,220.8 209.2,217.1 204.1,220.8 206,214.8    200.9,211 207.3,211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "209.2,231.8 211.2,237.8 217.6,237.8 212.4,241.6 214.4,247.7 209.2,243.9 204.1,247.7 206,241.6    200.9,237.8 207.3,237.8  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.f6bbfd56f82bd8fdd95db308a39ff35c.svg";
export { ForwardRef as ReactComponent };